exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Palette of colours used to distinguish repeated elements */\nnav {\n  position: relative;\n  float: left;\n}\nnav ul {\n  display: block;\n  margin: 15px 0;\n}\nnav ul li {\n  margin: 8px 0;\n  color: #808285;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\nnav ul li a {\n  color: #808285;\n  padding: 6px 10px;\n  display: block;\n  text-decoration: none;\n  text-align: center;\n}\nnav ul li a .svg-icon {\n  width: 32px;\n  display: block;\n  vertical-align: middle;\n  fill: #D8D8D8;\n  margin: 0 auto;\n}\nnav ul li a:hover {\n  color: #444;\n  border-radius: 50px;\n  text-decoration: none;\n}\nnav ul li a:hover .svg-icon {\n  fill: #444;\n}\nnav ul li a.active {\n  color: #157cc9;\n  padding: 6px 10px;\n  border-radius: 50px;\n  text-decoration: none;\n}\nnav ul li a.active .svg-icon {\n  fill: #178ae0;\n}\nnav ul li a.active:hover {\n  color: #1370b6;\n}\nnav ul li a.active:hover .svg-icon {\n  fill: #1476c0;\n}\nnav .top-divider {\n  margin-top: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/navigation/navigation.component.less
// module id = ../../../../../src/app/navigation/navigation.component.less
// module chunks = 2